export const COMPANIES_OVERVIEW_GET_DATA_REQUEST = "COMPANIES_OVERVIEW_GET_DATA_REQUEST";
export const COMPANIES_OVERVIEW_GET_DATA_RESULT = "COMPANIES_OVERVIEW_GET_DATA_RESULT";

export const GET_TOKEN_ONE_TIME = "GET_TOKEN_ONE_TIME";
export const GET_TOKEN_ONE_TIME_RESULT = "GET_TOKEN_ONE_TIME_RESULT";